import backendService from './backendService';

// More like this VOD
export function fetchMoreLikeThisVODService(contentId) {
  const max = 8;
  return backendService.content.v3.getMoreLikeThisVod(contentId, max);
}

// More like this EPG
export function fetchMoreLikeThisEPGService(contentId) {
  const max = 6;
  return backendService.content.v3.getMoreLikeThisEpg(contentId, max);
}
